
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-apply",
      function () {
        return require("private-next-pages/job-apply.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job-apply"])
      });
    }
  